/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 15:12:16
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-06 11:40:23
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/EnableConfig/index.tsx
 */
import React from 'react';

import css from './css.module.less';

import { Switch } from 'src/components/Antd';

import { useDispatch, useSelector } from 'react-redux';

import { useI18n } from 'src/hooks/useRouterChange';
import {
  getPageEnabled,
  onEnabledChange,
} from 'src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/slice';
import { i18nGet } from 'src/tools/tools';
const EnableConfig = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled } = props;
  const enabled = useSelector(getPageEnabled());
  const _d = useDispatch();
  const handleOnChange = (e) => {
    _d(onEnabledChange(e));
  };
  return (
    <div className={css.container}>
      <div className={css.contentContainer}>
        <div className={css.text}>{getI18n('general.sider.customisation')}</div>
        <Switch
          onChange={handleOnChange}
          checked={enabled}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
export default EnableConfig;
